// src/components/padrekko/qc/StateBadge.jsx
//
// Per-state badge for the Reclamation QC inspector. The state code matches
// the DB CHECK constraint (TX | NM) — anything else renders nothing.
//
// Amber for NM and sky for TX keeps the badges visually distinct from
// PadRekko's teal product header (`#16f2d4`) and from the amber-only
// "drawn / AI" accents already used elsewhere in the panel.

const STATES = {
  NM: {
    label:  "UL + NM OCD",
    cls:    "bg-amber-500/15 border-amber-500/40 text-amber-300",
  },
  TX: {
    label:  "UL + RRC + TCEQ",
    cls:    "bg-sky-500/15 border-sky-500/40 text-sky-300",
  },
};

export default function StateBadge({ stateCode }) {
  const s = STATES[stateCode];
  if (!s) return null;
  return (
    <span
      className={`inline-flex items-center px-1.5 py-0.5 rounded border
                  text-[10px] font-medium tracking-wide shrink-0 ${s.cls}`}
      title={`Active regulatory framework: ${s.label}`}
    >
      {s.label}
    </span>
  );
}
